<div *ngFor="let option of question.data.options">

    <app-view-quiz-answer-option [correct]="isOptionAnswerCorrect(question, option.value, answer)">
        <div class="text-semibold">
            {{ option.label }}
        </div>
    </app-view-quiz-answer-option>

</div>